import EventEmitter from "eventemitter3";

export const EVENTS = {
	activeButtonValidate: "activeButtonValidate",
	audiosEvents: {
		createAudioScene: "createAudioScene",
		createAudioActionButton: "createAudioActionButton",
		createAudioVoiceButton: "createAudioVoiceButton",
		controlVoices: "controlVoices",
		pauseActive: "pauseActive",
		pauseListen: "pauseListen"
	},
	audioInitByTopic: "audioInitByTopic",
	initIntroduction: "initIntroduction",
	back_to_main: "back_to_main",
	init_mainMenu: "init_mainMenu",
	init_introduction: "init_introduction",
	init_instructions: "init_instructions",
	final_instructions: "final_instructions",
	move_escritorio_introduction: "move_escritorio_introduction",
	hiddenMenusAnimations: "hiddenMenusAnimations",
	showMenuAnimations: "showMenuAnimations",
	loadingComplete: "loadingComplete",
	loadingCompleteScene: "loadingCompleteScene",
	initLoading: "initLoading",
	initLoadingScene: "initLoadingScene",
	selectCharacterIntroduction: "selectCharacterIntroduction",
	onLoadCharacter: "onLoadCharacter",
	characterAnimations: {
		idle: "idle",
		idle2: "idle2",
		saludo: "saludo",
		festejo: "festejo",
		pena: "pena",
		pensativo: "pensativo",
		hiddenModel: "hiddenModel",
		showModel: "showModel",
	},
	subtopicOne: {
		initScene: "subtopicOne",
		introduction: {
			initDialog: "initDialog",
		},
		activityOne: {
			visibleCharacterDress: "visibleCharacterDress",
			upChangeClothe: "shirtChange",
			middleChangeClothe: "middleChangeClothe",
			botoomChangeClothe: "botoomChangeClothe",
			onHiddenAllClothes: "onHiddenAllClothes",
			changeGenere: "changeGenere",
			moveCamareToCharacterDress: "moveCamareToCharacterDress",
		},
		activityTwo: {
			onListenCheck: "onListenCheck",
			moveIslanBox: "moveIslanBox",
			moveFloorSale: "moveFloorSale",
			moveStoreActTwo: "moveStoreActTwo",
			moveRoomColdActTwo: "moveRoomColdActTwo",
			moveFoodService: "moveFoodService",
			activeOutline: "activeOutline",
			showArea: "showArea",
		},
		activityThree: {
			initActivityMovement: "initActivityMovement",
			showHelpDialog: "showHelpDialog",
			openModalOxxo: "openModalOxxo",
			openClock: "openClock",
			closeClock: "closeClock",
			moveStore1: "moveStore1",
			moveStore2: "moveStore2",
			moveStore3: "moveStore3",
			moveStore4: "moveStore4",
			moveStore5: "moveStore5",
			clickMove: "clickMove",
			backClick: "backClick",
			upTower: "upTower",
			upTowerShowMessage: "upTowerShowMessage"
		},
	},
	subtopicTwo: {
		initScene: "subtopicTwoiniScene",
		activityone: {
			initInteractions: "initInteractions",
			findProduct: "findProduct",
			moveCamareGameOne: "moveCamareGameOne",
		},
		activityTwo: {
			completeFrenteo: "completeFrenteo",
			completeFondeo: "completeFondeo",
			initFondeo: "initFondeo",
			moveCamareTable: "sub1moveCamareTable",
		},
	},
	subtopicThree: {
		initScene: "subtopicThreeiniScene",
		activityone: {
			moveFride: "sub3moveFride",
			moveToDelixia: "moveToDelixia",
			hiddenTablet: "hiddenTablet",
			finishcoloqued: "finishcoloqued",
			restartactivity: "restartActivity",
			moveMonitor: "sub3moveMonitor",
			viewMonitor: {
				show: "sub3ShowMonitor",
				hidden: "sub3hiddenMonitor",
				img1: "sub3img1Monitor",
				img2: "sub3img2Monitor",
				img3: "sub3img3Monitor",
				img4: "sub3img4Monitor",
				img5: "sub3img5Monitor",
			},
			clickScreen: {
				moveScreen: "moveScreenMoveScreen",
				listerClickScreen: "listerClickScreen",
			}
		},
		activityTwo: {
			validateResponse: "validateResponse",
			countProductAct: "countProductAct",
		},
	},
	subtopicFour: {
		initScene: "subtopicFouriniScene",
		activityOne: {
			visibleHandler: "subFourVisibleHandler",
			moveToTicket: "moveToTicket",
			clickonTiket: "clickonTiket",
			moveZoom: "moveZoom",
			moveOut: "moveOut",
			clicktoscreen2: "clicktoscreen2",
			clicktoscreen3: "clicktoscreen3",
			clicktoscreen4: "clicktoscreen4",
			clicktoscreen5: "clicktoscreen5",
			clicktoscreen6: "clicktoscreen6",
			hiddenHandler: "hiddenHandler",
		},
		activityTwo: {
			failActivity: "failActivity",
			winActivity: "winActivity",
			onAnimateUSB: "onAnimateUSB",
			onAnimateCigarros: "onAnimateCigarros",
			onAnimateBotellas: "onAnimateBotellas",
			onAnmateDinero: "onAnmateDinero",
			killAllAnimations: "killAllAnimations",
			initActovity: "initActovity",
			visibleObjetProductsOnly: "visibleObjetProductsOnly",
			visibleObjetProductsAll: "visibleObjetProductsAll",
		},
	},
	subtopicFive: {
		initScene: "subtopicFive",
		activityOne: {
			moveToInvetary: "moveToInvetary",
			visibleHandler: "visibleHandler",
			clicktoscreen1: "clicktoscreen1",
			moveToPositionInit: "moveToPositionInit",
			hiddenHandler: "hiddenHandler",
		},
	},
	subtopicSix: {
		initScene: "subtopicSix",
		activityOne: {
			moveBannerCheckout: "moveBannerCheckout",
			moveBannerCocacola: "moveBannerCocacola",
			moveBannerFastFood: "moveBannerFastFood",
			moveBannerColdRoom: "moveBannerColdRoom",
			moveBannerSide: "moveBannerSide",
			moveBannerCopeteHeader: "moveBannerCopeteHeader",
			moveBannerEntry: "moveBannerEntry",
			clickedRayCaster: "clickedRayCaster",
			stepUseRayCaster: "stepUseRayCaster",
		},
	},
	subtopicSeven: {
		initScene: "subtopicSeven",
	},
	team2: {
		introduction: "team2Introduction",
		subtopicOne: {
			initScene: "team2subtopicOne",
			activityOne: {
				clickedRayCaster: "team2ClickedRayCaster",
				stepUseRayCaster: "team2StepUseRayCaster",
				activeEmissiveIntensitySalchichas: "team2ActiveEmissiveIntensitySalchichas",
				activeEmissiveIntensityVerduras: "team2ActiveEmissiveIntensityVerduras",
				activeEmissiveIntensityClick: "theme2activeEmissiveIntensityClick"
			},
			activityTwo: {
				visibleFasFood: "theme2FastFood",
				moveInClearContainer: "theme2moveInClearContainer",
				onActivityClean: "theme2onActivityClean",
				finishCleanAct2: "theme2finishCleanAct2",
			},
			activityThree: {
				moveToTableCoffe: "theme2moveToTableCoffe",
				visibleObjectContainerCleaner: "team2Act3visibleObjectContainerCleaner",
				viewObjectsOnly: "theme2viewObjectsOnly",
				finishAnimation: "theme2finishAnimation",
				moveInitActThree: "theme2moveInitActThree",
			},
		},
		subtopicTwo: {
			initScene: "team2subtopicTwo",
			clickedRayCaster: "team2Topic2ClickedRayCaster",
			stepUseRayCaster: "team2Topic2StepUseRayCaster",
			activityTwo: {
				moveCashRegister: "team2moveCashRegister",
			},
			activitySix: {
				moveYelox: "theme2moveYelox"
			},
			activityEight: {
				moveTable: "theme2activityEightmoveTable",
				checkMachine: "theme2activityEightcheckMachine",
			}
		},
		subtopicThree: {
			initScene: "team2subtopicThree",
			finishClickAct3Part2: "team2Topic3finishClickAct3Part2",
			clickedRayCaster: "team2Topic3ClickedRayCaster",
			stepUseRayCaster: "team2Topic3StepUseRayCaster",
			moveCoffeTable: "theme2Sub3moveCoffeTable",
			initPosicitionCamare: "theme2InitPosicitionCamare",
			activityOne: {
				visibleCoffeMake: "team2visibleCoffeMake",
				eliminateAnimation: "team2EliminateAnimation",
			},
			activityTwo: {
				animatePartCoffeMaker: "team2animatePartCoffeMaker",
			},
			activityThree: {
				initAct3Part2: "theme2initAct3Part2",
				moveMachineCoffe: "team2MoveMachineCoffe",
				visibilityCupWhite: "team2VisibilityCupWhite",
				hiddenCupWhite: "team2HiddenCupWhite",
				tooltip: {
					containerGrain: "team2TooltipContainerGrain",
					llave: "team2Tooltipllave",
					pantalla: "team2Tooltippantalla",
					botonselecion: "team2Tooltipbotonselecion",
					dispensador: "team2Tooltipdispensador",
					charolaVaso: "team2TooltipcharolaVaso",
					hiddenTooltip: "team2hiddenTooltip",
				},
				eliminateAnimations: "team2EliminateAnimations",
				moveTableCoffe: "team2MoveTableCoffe",
				moveMachineKey: "team2MoveMachineKey",
				animationKeyMachine: "team2AnimationKeyMachine",
				animationKeyMachineFinish: "team2AnimationKeyMachineFinish",
				animatioGarrafon: "team2AnimatioGarrafon",
				animatioGarrafonFinish: "team2AnimatioGarrafonFinish",
				hiddenGarrafon: "team2hiddenGarrafon",
				visibleunCuartoAct3: "team2visibleunCuartoAct3",
				hiddenunCuartoAct3: "team2hiddenunCuartoAct3",
				moveMachineContainer: "team2MoveMachineContainer",
				visibleContainerStepFour: "team2visibleContainerStepFour",
				containerStepFourFinish: "team2containerStepFourFinish",
				containerStepSevenFinish: "team2containerStepSevenFinish",
				stepUseMachineCoffe: {
					stepOne: "team2MachineCoffeOne",
					stepTwo: "team2MachineCoffeTwo",
					stepThree: "team2MachineCoffeThree",
					stepFour: "team2MachineCoffeFour",
					stepFive: "team2MachineCoffeFive",
					stepSix: "team2MachineCoffeSix",
					stepSeven: "team2MachineCoffeSeven",
				},
				finishCafeteraKobaltoProceso: "team2FinishCafeteraKobaltoProceso",
				limpiezaKobalto: {
					moveMachineCleanKobalto: "team2limpiezaKobaltoMachineMove",
					steps: {
						trapo: "team2limpiezaKobaltostepstrapo",
						papel: "team2limpiezaKobaltostepspapel",
						showConetenedorInit: "team2limpiezaKobaltostepsshowConetenedorInit",
						showConetenedorFinish: "team2limpiezaKobaltostepsshowConetenedorFinish",
						removeCoffeContainer: "team2limpiezaKobaltostepsremoveCoffeContainer",
						saveContenedorInit: "team2limpiezaKobaltostepssaveContenedorInit",
						saveContenedorFinish: "team2limpiezaKobaltostepssaveContenedorFinish",
					},
					moveMachineLimpieza: "team2MoveMachineLimpieza",
					stepTooltipOne: {
						azucar: "team2limpiezaKobaltostepTooltipOneazucar",
						splenda: "team2limpiezaKobaltostepTooltipOnesplenda",
						vaso4: "team2limpiezaKobaltostepTooltipOnevaso4",
						vaso12: "team2limpiezaKobaltostepTooltipOnevaso12",
						vaso16: "team2limpiezaKobaltostepTooltipOnevaso16",
						finishStep: "team2limpiezaKobaltostepTooltipOnefinishStep",
					},
					stepTooltipTwo: {
						initStep: "team2limpiezaKobaltostepTooltipTwoinitStep",
						vasostooltip: "team2limpiezaKobaltostepTooltipTwovasostooltip",
						tapasextras: "team2limpiezaKobaltostepTooltipTwotapasextras",
						tapas: "team2limpiezaKobaltostepTooltipTwotapas",
						portamangas: "team2limpiezaKobaltostepTooltipTwoportamangas",
						finishStep: "team2limpiezaKobaltostepTooltipTwofinishStep",
					},
				},
			},
			activityFour: {
				moveMachineKrea: "team2moveMachineKrea",
				visibleunCuartoAct4: "team2visibleunCuartoAct4",
				hiddenunCuartoAct4: "team2hiddenunCuartoAct4",
				tooltipMachineKrea: {
					K_Contenedor_de_grano: "team2activityFourtooltipMachineKreaK_Contenedor_de_grano",
					K_Llave: "team2activityFourtooltipMachineKreaK_Llave",
					K_PantallaDeDatos: "team2activityFourtooltipMachineKreaK_PantallaDeDatos",
					K_BotonSeleccion: "team2activityFourtooltipMachineKreaK_BotonSeleccion",
					K_Dispensador: "team2activityFourtooltipMachineKreaK_Dispensador",
					K_ParillaDeEscurrimiento: "team2activityFourtooltipMachineKreaK_ParillaDeEscurrimiento",
					K_ParillaPortaVaso: "team2activityFourtooltipMachineKreaK_ParillaPortaVaso",
					finishTooltipMachineKrea: "team2finishTooltipMachineKrea",
				},
				visibleGarrafon: "team2visibleGarrafon",
				hiddenGarrafon: "team2hiddenGarrafon",
				animationLlaveKreaInit: "team2animationLlaveKreaInit",
				animationLlaveKreaFinish: "team2animationLlaveKreaFinish",
				animationHiddenContenedor: "team2animationHiddenContenedor",
				animationVisibleContenedor: "team2animationVisibleContenedor",
				animationSaveContenedorInit: "team2animationSaveContenedorInit",
				animationSaveContenedorFinish: "team2animationSaveContenedorFinish",
				animationCloseAnimationInit: "team2animationCloseAnimationInit",
				animationCloseAnimationFinish: "team2animationCloseAnimationFinish",
			},
			activityFive: {
				visibleCupWater: "team2visibleCupWater",
				visibleBagFrappe: "team2visibleBagFrappe",
				hiddenCupAndFrappe: "team2hiddenCupAndFrappe",
				animationsSaveCupWaterInit: "team2animationsSaveCupWaterInit",
				animationsSaveCupWaterFinish: "team2animationsSaveCupWaterFinish",
				animationsCloseCupWaterInit: "team2animationsCloseCupWaterInit",
				animationsCloseCupWaterFinish: "team2animationsCloseCupWaterFinish",
				visibleexpiration: "team2visibleexpiration",
				hiddenexpiration: "team2hiddenexpiration",
				tooltip: {
					off: "team2tooltipAct5off",
					hiddenoff: "team2tooltipAct5hiddenoff",
					on: "team2tooltipAct5on",
					hiddenon: "team2tooltipAct5hiddenon",
					alert: "team2tooltipAct5alert",
					hiddenalert: "team2tooltipAct5hiddenalert",
					degrees: "team2tooltipAct5degrees",
					hiddendegrees: "team2tooltipAct5hiddendegrees",
				},
			},
		},
	},
	tema3: {
		introduction: "theme3Introduction",
		listenClick: "theme3ListenCheck",
		actOne: {
			initScene: "theme3ActOneInitScene",
			moveBread: "theme3MoveBread",
			clickBread: "theme3ClickBread"
		},
		actTwo: {
			viewPanes: "theme3ViewPanes"
		},
		actFour: {
			moveCamarePosition: "theme3MoveCamarePosition",
			animationObjecs: "theme3animationObjecs",
			finishMoveAnimation: "theme3finishMoveAnimation"
		},
		topic2: {
			initScene: "theme3TopicOneInitScene",
			actOne: {
				moveAroundStation: "theme3MoveAroundStation",
				stepActivateInformation: "theme3StepActivateInformation",
				finishMoveAnimation: "theme3finishMoveAnimationTopic2"
			},
			actTwo: {
				clickRayCaster: "theme3SubTwoclickRayCaster",
				moveWanner: "theme3SubTwoMoveWanner",
				activyObj: "theme3SubTwoactivyObj"
			},
			actThree: {
				actKoxka: "actKoxka"
			},
			actFour: {
				actBolsa: "actBolsa",
				finishMoveActBolsa: "finishMoveActBolsa"
			},
			actFive: {
				actCleanKoaxka: "actCleanKoaxka",
				finishMoveactCleanKoaxka: "finishMoveactCleanKoaxka"
			}
		},
		topic3: {
			initScene: "theme3TopicTwoInitScene",
			actOne: {
				actScene: "theme3ActSceneTopic3"
			},
			actTwo: {
				checkStep: "theme3CheckStepView",
				actScene: "theme3ActSceneTopic3Sub1",
				finishActScene: "theme3AFinishActSceneTopic3Sub1",
			},
			actThree: {
				actScene: "theme3ActSceneTopic3Sub3",
				finishActScene: "theme3AFinishActSceneTopic3Sub3",
			},
			actFour: {
				actScene: "theme3ActSceneTopic3Sub3act4",
				finishActScene: "theme3AFinishActSceneTopic3Sub3act4",
			}
		}
	},
	tema4: {
		subtopicOne: {
			initScene: 'tema4_subtema1',
			activityTwo: {
				moveCameraWithNeto: "tema4servicioMemorableGoWithNeto",
				returnToDesk: "tema4servicioMemorableReturnToDesk"
			}
		},
		subtopicTwo: {
			initScene: "tema4_subtema2",
			activityOne: {
				moveCameraOverDesk: "tema4herramientasDeLaCaja_moveOverDesk",
				amplifyDesk: "tema4herramientasDeLaCaja_amplifyDesk",
				showModels: "tema4herramientasDeLaCaja_showModels",
				finishActivity: "tema4herramientasDeLaCaja_finishActivity",
				hideModels: "tema4herramientasDeLaCaja_hideModels",
			},
			activityTwo: {
				moveCameraOverKeyboard: "tema4herramientasDeLaCaja_moveOverKeyboard",
				showKeyboard: "tema4herramientasDeLaCaja_showKeyboard",
				hideKeyboard: "tema4herramientasDeLaCaja_hideKeyboard",
				showSecondDialog: "tema4herramientasDeLaCaja_showSecondDialog",
			},
		},
		subtopicThree: {
			initScene: "tema4_subtema3",
			activityOne: {
				showBillets: "tema4formasDePago_showBillets",
				hideBillets: "tema4formasDePago_hideBillets",
			},
			activityTwo: {
				showMonitor: "tema4formasDePago_showMonitor",
				hideMonitor: "tema4formasDePago_hideMonitor",
				moveCameraToMonitor: "tema4formasDePago_moveCameraToMonitor",
			},
		},
		subtopicFour: {
			initScene: "tema4_subtema4",
			activityTwo: {
				img1monitor: "tema4cobroDeProductos_img1monitor",
				img2monitor: "tema4cobroDeProductos_img2monitor",
			},
			activityThree: {
				showKeyboard: "tema4cobroDeProductos_showKeyboard",
				keyboardQuiz: "tema4cobroDeProductos_keyboardQuiz",
				winKeyboardQuiz: "tema4cobroDeProductos_winKeyboardQuiz",
				failKeyboardQuiz: "tema4cobroDeProductos_failKeyboardQuiz",
				showBillets: "tema4cobroDeProductos_showBillets",
				moveCameraToBillets: "tema4cobroDeProductos_moveCameraToBillets",
				changebilletsTexture: "tema4cobroDeProductos_changebilletsTexture",
				billetsQuiz: "tema4cobroDeProductos_billetsQuiz",
				winBilletsQuiz: "tema4cobroDeProductos_winBilletsQuiz",
				failBilletsQuiz: "tema4cobroDeProductos_failBilletsQuiz",
			},
			activityFour: {
				img3monitor: "tema4cobroDeProductos_img3monitor",
			},
			activityFive: {
				quizOne: "tema4cobroDeProductos_quizOne",
				quizTwo: "tema4cobroDeProductos_quizTwo",
				quizThree: "tema4cobroDeProductos_quizThree",
				respondQuizOne: "tema4cobroDeProductos_respondQuizOne",
				respondQuizTwo: "tema4cobroDeProductos_respondQuizTwo",
				respondQuizThree: "tema4cobroDeProductos_respondQuizThree",
				validateQuizOne: "tema4cobroDeProductos_validateQuizOne",
				validateQuizTwo: "tema4cobroDeProductos_validateQuizTwo",
				validateQuizThree: "tema4cobroDeProductos_validateQuizThree",
				moveCameraOverKeyboard: "tema4cobroDeProductos_moveCameraOverKeyboard",
				img4monitor: "tema4cobroDeProductos_img4monitor",
				showPinPad: "tema4cobroDeProductos_showPinPad",
				insertCard: "tema4cobroDeProductos_insertCard",
				removeCard: "tema4cobroDeProductos_removeCard",
			},
		},
		subtopicFive: {
			initScene: "tema4_subtema5",
			activityTwo: {
				img5monitor: "tema4sinergia_img5monitor",
				changeActivity: "tema4sinergia_changeActivity",
				respondChangeActivity: "tema4sinergia_respondChangeActivity",
				validateChangeActivity: "tema4sinergia_validateChangeActivity",
			},
		},
		subtopicSix: {
			initScene: "tema4_subtema6",
			activityOne: {
				moveCamera: "tema4lavadoDeDinero_moveCamera",
			},
		},
	},
	tema5: {
		subtopicOne: {
			initScene: 'tema5_subtema1',
			activityOne: {
				clearKeyAnimation: "tema5corresponsalias_clearKeyAnimation",
				animateKey: "tema5corresponsalias_animateKey",
				changeImageMonitor: "tema5corresponsalias_changeImageMonitor",
				buttonScreenPosition: "tema5corresponsalias_buttonScreenPosition",
				buttonScreenVisibility: "tema5corresponsalias_buttonScreenVisibility",
			}
		},
		subtopicTwo: {
			initScene: "tema5_subtema2",
			activityOne: {
				amplifyDesk: "tema5corresponsalias_amplifyDesk",
				showOrHideModels: "tema5corresponsalias_showOrHideModels",
				touchObject: "tema5corresponsalias_touchObject",
				nextUI: "tema5corresponsalias_nextUI",
			}
		},
		subtopicThree: {
			initScene: "tema5_subtema3",
		},
		subtopicFour: {
			initScene: "tema5_subtema4",
		},
	},
	tema6: {
		introduction: "theme6Introduction",
		intro: {
			monitorActivi: "theme6MonitorActivi",
			listenMonitor: "theme6ListenMonitor",
		},
		topic1: {
			initScene: "theme6ActOneInitScene",
			actScene: "theme6ActSceneSub1",
			listenScene: "theme6ListenSceneSub1"
		},
		topic2: {
			initScene: "theme6ActOneInitSceneTopic2",
			actScene: "theme6ActSceneSub2",
			listenScene: "theme6ListenSceneSub2"
		},
		topic3: {
			initScene: "theme6ActOneInitSceneTopic3",
			actScene: "theme6ActSceneSub3",
			listenScene: "theme6ListenSceneSub3"
		},
		topic4: {
			initScene: "theme6ActOneInitSceneTopic4",
			actScene: "theme6ActSceneSub4",
			listenScene: "theme6ListenSceneSub4"
		},
		topic5: {
			initScene: "theme6ActOneInitSceneTopic5",
			actScene: "theme6ActSceneSub5",
			listenScene: "theme6ListenSceneSub5"
		},
	},
	tema7: {
		introduction: "theme7Introduction",
		intro: {
		},
		topic1: {
			initScene: "theme7ActOneInitScene",
			actScene: "theme7ActSceneSub1",
			listenScene: "theme7ListenSceneSub1"
		},
		topic2: {
			initScene: "theme7ActTwoInitScene",
			actScene: "theme7ActSceneSub2",
			listenScene: "theme7ListenSceneSub2"
		},
	},
	tema8: {
		introduction: "theme7Introduction",
		intro: {
		},
		topic1: {
			initScene: "theme8ActOneInitScene",
			actScene: "theme8ActSceneSub1",
			listenScene: "theme8ListenSceneSub1"
		},
		topic2: {
			initScene: "theme8ActTwoInitScene",
			actScene: "theme8ActSceneSub2",
			listenScene: "theme8ListenSceneSub2"
		},
	},
	tema9: {
		introduction: "theme9Introduction",
		topic1: {
			initScene: "theme9ActOneInitScene",
			actScene: "theme9ActSceneSub1",
			listenScene: "theme9ListenSceneSub1"
		},
	},
};

const ObserverEmitter = new EventEmitter();
export default ObserverEmitter;
